module.exports = __webpack_public_path__ + "img/waiter.89eecfc4.svg";